<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Clients</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="add" @click="addClient" color="danger" type="border" v-if="abilities.can('create', 'clients')"
            >Add</vs-button
          >
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">
          <v-select v-model="per_page" :options="size_per_page"/>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="7"
          vs-sm="4"
          vs-xs="12"
        >
         <div class="p-1">
            <span>Search companies: </span>
          </div>
         

          <ClientAutocomplete
          :key="companySearchComponentKey" 
            class="searchbox"
            :list="searchCompany"
            :searchOn="'company_or_registration_no'"
            @event-name="handleChildEvent"
          ></ClientAutocomplete>
                    <vs-icon class="pl-5 pointer" icon="cancel" @click="resetClient" size="small"
            ></vs-icon
          >

        </vs-col>
        <vs-col vs-type="flex" vs-lg="3" vs-sm="4" vs-xs="12">
                          <!-- <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination> -->

         
        </vs-col>
      </vs-row>


      <vs-table
      :sst="true"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
      v-model="selected"
      :total="totalItems"
      :data="clients">



      <!-- <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="clients"
      > -->
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th>Registration No.</vs-th>
          <vs-th sort-key="company_name">
            Company
        </vs-th>
          <vs-th>Switchboard</vs-th>
          <vs-th>Website</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].company_registration_number">
              {{ data[indextr].company_registration_number }}
            </vs-td>
            <vs-td :data="data[indextr].company_name">
              {{ data[indextr].company_name }}
            </vs-td>
            <vs-td :data="data[indextr].phone">
              <!-- {{data[indextr].phone}} -->
            <template v-for="phone in data[indextr].phone">
                <template v-for="p_type in phone.phone_type">
                  <template v-if="phone.id == p_type.phone_id">
                    <template v-if="p_type.type == 'head_office_switchboard'">
                      <p class="p-2">
                        {{ phone.phone_no }}
                      </p>
                    </template>
                  </template>
                </template>
              </template>
            </vs-td>
            <vs-td :data="data[indextr].web">
              <template
                v-for="website in data[indextr].web"
              >
                <span class="p-5">
                  <p>{{ website.url }}</p>
                </span>
              </template>
            </vs-td>     
            <vs-td :data="data[indextr].actions">
              <vs-icon v-if="abilities.can('read', 'clients')"
                class="ml-10 removeButton" size="18px" 
                @click="viewClient(data[indextr].id)"
                color="success"
                icon="visibility"
              ></vs-icon>
              <vs-icon v-if="abilities.can('update', 'clients')"
                class="ml-10 removeButton" size="18px" 
                @click="editClient(data[indextr].id)"
                color="success"
                icon="edit"
              ></vs-icon>
              <vs-icon v-if="abilities.can('delete', 'clients')"
                class="ml-10 removeButton" size="18px" 
                @click="confirmDeleteClient(data[indextr].id)"
                color="success"
                icon="delete"
              ></vs-icon>
            </vs-td>
            <template class="expand-user" slot="expand">
            <div class="con-expand-users">
             <table class="address_table">
  <tr>
    <td class="address_td"></td>
    <th class="address_th" scope="col">Address 1</th>
    <th class="address_th" scope="col">Address 2</th>
    <th class="address_th" scope="col">Address 3</th>
    <th class="address_th" scope="col">City</th>
    <th class="address_th" scope="col">County</th>
    <th class="address_th" scope="col">Postcode</th>
    <th class="address_th" scope="col">Country</th>
  </tr>
  <tr>
    <th class="address_th" scope="row">Head Office</th>
    <td class="address_td"> {{ data[indextr].head_office_address_1 }}</td>
    <td class="address_td"> {{ data[indextr].head_office_address_2 }}</td>
    <td class="address_td"> {{ data[indextr].head_office_address_3 }}</td>
    <td class="address_td"> {{ data[indextr].head_office_city }}</td>
    <td class="address_td"> {{ data[indextr].head_office_county }}</td>
    <td class="address_td"> {{ data[indextr].head_office_postcode }}</td>
    <td class="address_td"> {{ data[indextr].head_office_country }}</td>
  </tr>
  <tr>
    <th class="address_th" scope="row">Registered Office</th>
    <td class="address_td"> {{ data[indextr].registered_office_address_1 }}</td>
    <td class="address_td"> {{ data[indextr].registered_office_address_2 }}</td>
    <td class="address_td"> {{ data[indextr].registered_office_address_3 }}</td>
    <td class="address_td"> {{ data[indextr].registered_office_city }}</td>
    <td class="address_td"> {{ data[indextr].registered_office_county }}</td>
    <td class="address_td"> {{ data[indextr].registered_office_postcode }}</td>
    <td class="address_td"> {{ data[indextr].registered_office_country }}</td>
  </tr>
</table>
            </div>
          </template>
          </vs-tr>
        </template>
      </vs-table>
      <template>
        <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination>
      </template>
    </vx-card>
    
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data: () => ({
    sortedData: [],
      sortedbyASC: true,
    totalItems:10,
    abilities : null,
    companySearchComponentKey:0,
    selected: [],
    log: [],
    clients: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    size_per_page: [10,20,50,100,500],
    per_page: 10,
    paginationAttr:{
      'page_no':1,
      'per_page':10
    }
  }),
  components: {
    ClientAutocomplete,
    "v-select": vSelect
  },
  computed: {
  },
  watch: {
    currentx: function(val) {
      this.paginationSetPageSize()
    },
    per_page:function(val){
            this.paginationSetPageSize()
    }
  },
  methods: {
    handleSort(sortBy, active) {

if(sortBy == 'company_name'){
  if (this.sortedbyASC) {
  this.clients.sort((x, y) => (x[sortBy] > y[sortBy] ? -1 : 1));
  this.sortedbyASC = false;
} else {
  this.clients.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
  this.sortedbyASC = true;
}
}






// alert("Dsdfsdfsdf")
// console.log(`the user ordered: ${key} ${active}`);
},
    resetClient(){
        this.fetchClients()
              this.companySearchComponentKey += 1;
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        'page_no':this.currentx,
        'per_page':this.per_page
      }
      this.fetchClients();
    },
    searchCompany(inputValue) {
      return this.$store
        .dispatch("clientsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleClientsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addClient() {
      this.$router.push({ path: "clients/add" });
    },
    handleSearch(searching) {
      let _print = `The user searched for: ${searching}\n`
      this.$refs.pre.appendChild(document.createTextNode(_print))
    },
    handleChangePage(page) {
      let _print = `The user changed the page to: ${page}\n`
      this.$refs.pre.appendChild(document.createTextNode(_print))
    },
    viewClient(id) {
      this.$router.replace("/clients/" + id);
    },
    editClient(id) {
      this.$router.replace("/clients/edit/" + id);
    },
    handleChildEvent(){
      this.clients = moduleClientsManagement.state.clients.datas
      // console.log("Client" , this.clients)
    },
    confirmDeleteClient(id) {
      this.selected_id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Client`,
        accept: this.deleteClient,
        acceptText: "Delete"
      });
    },
    deleteClient() {
      this.$store
        .dispatch("clientsManagement/removeClient", this.selected_id)
        .then(res => {
          if (res.data.status == "success") {
            this.fetchClients();
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Client Deleted",
        text: "The client was successfully deleted"
      });
    },
    fetchClients() {
      this.$store
        .dispatch("clientsManagement/fetchAllClients", this.paginationAttr)
        .then(res => {
          this.clients = moduleClientsManagement.state.clients.datas;
          this.total = moduleClientsManagement.state.clients.total;
          this.per_page = moduleClientsManagement.state.clients.per_page;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  },
  created() {
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });
    if (!moduleClientsManagement.isRegistered) {
      this.$store.registerModule(
        "clientsManagement",
        moduleClientsManagement
      );
      moduleClientsManagement.isRegistered = true;
    }
    this.fetchClients();
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.pointer{
  cursor: pointer;
}

.item.expanded{
    background-color: white !important;
    color: black !important;
}

.tr-table-state-primary, .vs-table-primary .is-selected {
    background: none !important;
    box-shadow: none !important;
}


.tr-table-state-primary, .vs-table-primary .is-selected {
    color: #626262 !important;
    -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary),1)!important;
    box-shadow: 0 0 1px 0 rgba(var(--vs-primary),1)!important;
}

.address_th{
  padding: 30px;
}

.address_td{
  padding: 30px;
      font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
